import { render, staticRenderFns } from "./ipSwitch.vue?vue&type=template&id=2ccd9c7b&scoped=true"
import script from "./ipSwitch.vue?vue&type=script&lang=js"
export * from "./ipSwitch.vue?vue&type=script&lang=js"
import style0 from "./ipSwitch.vue?vue&type=style&index=0&id=2ccd9c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd9c7b",
  null
  
)

export default component.exports